import { IsNotEmpty, IsUUID } from 'class-validator';

import type { FileInputValue } from '@vk-hr-tek/ui/input';

export class ImportAttorneyValuesDto {
  @IsNotEmpty()
  @IsUUID()
  userId: string;

  @IsNotEmpty()
  @IsUUID()
  companyId: string;

  @IsNotEmpty()
  xml: FileInputValue;

  @IsNotEmpty()
  sig: FileInputValue;
}
